import { number, string, shape, arrayOf } from 'prop-types';
import entityTypes from './entityTypes';

export default arrayOf(
  shape({
    entity: shape({
      id: string.isRequired,
      type: entityTypes.isRequired,
    }).isRequired,
    data: arrayOf(
      shape({
        periodKey: number.isRequired,
        value: number,
      }).isRequired
    ).isRequired,
  })
);
